import { render, staticRenderFns } from "./AnimalData.vue?vue&type=template&id=7e73bbb7&scoped=true"
import script from "./AnimalData.vue?vue&type=script&lang=ts"
export * from "./AnimalData.vue?vue&type=script&lang=ts"
import style0 from "./AnimalData.vue?vue&type=style&index=0&id=7e73bbb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e73bbb7",
  null
  
)

export default component.exports